// MARK://dhk8/admin-shell/components/ThemeSwitcher
// Sun ↔ Moon toggle in the admin topbar. Copied from apps/dhk8-pos's ThemeSwitcher
// (plain CSS, --pos-* tokens, ≥44pt touch target).

import { Sun, Moon } from 'lucide-react'
import { useThemeStore } from '../stores/theme.store.js'
import { t } from '../i18n/es-MX.js'

export default function ThemeSwitcher() {
  const theme = useThemeStore((s) => s.theme)
  const toggleTheme = useThemeStore((s) => s.toggleTheme)
  const isDark = theme === 'dark'
  const label = isDark ? t('theme.toLight') : t('theme.toDark')
  const Icon = isDark ? Sun : Moon
  return (
    <button type="button" className="pos-theme-switch" onClick={toggleTheme} aria-label={label} title={label}>
      <Icon size={18} aria-hidden />
      <style>{styles}</style>
    </button>
  )
}

const styles = `
  .pos-theme-switch {
    display: inline-flex; align-items: center; justify-content: center;
    width: var(--pos-touch-target, 44px); height: var(--pos-touch-target, 44px); flex-shrink: 0;
    border: 1px solid transparent; border-radius: var(--pos-radius-md);
    background: transparent; color: var(--pos-fg-tertiary); cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition: color var(--pos-duration-fast) var(--pos-ease-out), background var(--pos-duration-fast) var(--pos-ease-out);
  }
  .pos-theme-switch:hover { color: var(--pos-fg); background: var(--pos-elevated); }
  .pos-theme-switch:active { transform: scale(.96); }
  .pos-theme-switch:focus-visible { outline: none; border-color: var(--pos-tint); box-shadow: 0 0 0 3px var(--pos-tint-soft); }
`
